import { createSlice } from '@reduxjs/toolkit';
import { IJob } from '../../../../dto';
import { setJobs } from '../actions';
import { MN_JOBS, TYPE_LIST } from '../../../../common';

export interface JobsState {
  data: IJob[];
  loading: boolean;
  error: string | null;
}

const initialState: JobsState = {
  data: [],
  loading: false,
  error: null,
};

export const jobsSlice = createSlice({
  name: `${MN_JOBS}/${TYPE_LIST}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setJobs, (state, { payload }) => {
      state.data = payload;
    });
  },
});
